export default __webpack_public_path__ + "static/article-15-money-management-hacks-e70817f2a281b5d14083ee59288be3c8.jpg";